/**
 * @desc 历史库存批次处理
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.handleHistoricalInventoryBatch.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/handleHistoricalInventoryBatch`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
